__turbopack_context__.v({
  "banner_iframe_video": "Banner-module-scss-module__vB7GfW__banner_iframe_video",
  "banner_text": "Banner-module-scss-module__vB7GfW__banner_text",
  "banner_text_container": "Banner-module-scss-module__vB7GfW__banner_text_container",
  "overlay": "Banner-module-scss-module__vB7GfW__overlay",
});
